import { render, staticRenderFns } from "./NewsCount.vue?vue&type=template&id=60e2b737&"
import script from "./NewsCount.vue?vue&type=script&lang=js&"
export * from "./NewsCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports